import { AfterViewInit, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/services/auth.service';
import { FullModeService } from 'src/app/services/full-mode.service';
import { KeycloakAuthService } from 'src/app/services/keyclok-auth.service';
import { LanguageService } from 'src/app/services/language-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
  @Input() logoImg!: string;
  @Input() stickyLogoImg = '';
  @Input() stickyHeaderWhite = false;
  @Input() enableStickyHeader = true;
  @Input() classHeader!: string;
  isLoggedIn = false;
  opened = false;
  displayLogoImg = '';
  private isSticky = false;
  private readonly triggerPoint = 80;
  private readonly onScroll = () => this.updateHeaderOnScroll();

  constructor(
    public translateService: TranslateService,
    public langService:LanguageService,
    public route:ActivatedRoute,
    public fullModeService: FullModeService,
    public authService:AuthService,
    public keycloakAuthService:KeycloakAuthService
  ) {
    this.authService.loggedIn$.subscribe(() => this.syncLoggedInState());
    this.keycloakAuthService.loggedIn$.subscribe(() => this.syncLoggedInState());
  }

  ngOnInit(): void {
    this.displayLogoImg = this.logoImg;
    this.syncLoggedInState();
    this.translateService.setDefaultLang(this.langService.activeLanguage);

    this.route.queryParamMap.subscribe((params) => {
      const fullModeParam = params.get('fullMode') || '';
      if(fullModeParam !== ''){
        this.fullModeService.fullMode = fullModeParam==='true'
      }else{
        this.fullModeService.fullMode
      }
    })
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['logoImg'] && !this.isSticky) {
      this.displayLogoImg = this.logoImg;
    }
  }

  ngAfterViewInit(): void {
    if (this.enableStickyHeader) {
      this.updateHeaderOnScroll();
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    const nav1 = document.getElementById("features");
    const dropdowns = document.querySelectorAll('.dropdown');
    dropdowns.forEach((dropdown) => {
      dropdown.addEventListener('click', () => {
        const toggle = dropdown.querySelector('.dropdown-menu');
        if(toggle){
          if(!toggle.classList.contains('active-dropdown')){
            toggle.classList.add('active-dropdown');
          }else{
            toggle.classList.remove('active-dropdown');
          }
        }
      })
    });

    if (nav1) {
      const navScrollHandler = () => {
        const yOffset = window.scrollY;
        const nav1Offset = nav1.getBoundingClientRect();
        const contentNav1 = nav1Offset.top + window.scrollY - window.innerHeight;
        if (yOffset >= contentNav1) {
          const navLinks = nav1.querySelectorAll('.row li a');
          navLinks.forEach(link => {
            link.classList.remove('active');
          });
          const selectedLink = nav1.querySelector('a[aria-selected="true"]');
          if (selectedLink) {
            selectedLink.classList.add('active');
          }
        }
      };
      window.addEventListener('scroll', navScrollHandler, { passive: true });
    }
  }

  ngOnDestroy(): void {
    if (this.enableStickyHeader) {
      window.removeEventListener('scroll', this.onScroll);
    }
  }

  onChangeLand(lang: string){
    this.translateService.setDefaultLang(lang);
    this.translateService.use(lang);
    this.langService.activeLanguage = lang;
    localStorage.setItem('language', lang);
    console.log('lang', lang)
  }

  openMobileMenu(){
      let menu = document.getElementById('navbarSupportedContent')
      if( !this.opened){
        menu?.classList.add('show')
        this.opened = true
      }else{
        menu?.classList.remove('show')
        this.opened = false
      }
  }
  redirectToCreator(){
    if(this.fullModeService.fullMode==false){
      if(environment.development){
        window.open('https://dev.creator.se2.tech/#/?fullMode=false', '_blank');
      }else if(environment.staging){
        window.open('https://stage.creator.se2.tech/#/?fullMode=false', '_blank');
      }else{
        window.open('https://creator.se2.tech/#/?fullMode=false', '_blank');
      }
    }else{
      if(environment.development){
        window.open('https://dev.creator.se2.tech/#/?fullMode=true', '_blank');
      }else if(environment.staging){
        window.open('https://stage.creator.se2.tech/#/?fullMode=true', '_blank');
      }else{
        window.open('https://creator.se2.tech/#/?fullMode=true', '_blank');
      }
    }
  }
  redirectToTicket(){
    window.open('https://ticket.se2.tech', '_blank')
  }

  logout(){
    this.authService.logout();
    this.keycloakAuthService.loggedIn$.next(false);
    this.syncLoggedInState();
  }

  private syncLoggedInState(): void {
    this.isLoggedIn = this.authService.isLoggedIn();
  }

  private updateHeaderOnScroll(): void {
    const header = document.getElementById('main-header');
    if (!header) {
      return;
    }

    const shouldStick = window.scrollY >= this.triggerPoint;

    if (shouldStick) {
      header.classList.add('menu-sticky', 'animated', 'slideInDown');
      if (this.stickyHeaderWhite) {
        header.classList.add('slideWhite');
      }
      if (this.stickyLogoImg) {
        this.displayLogoImg = this.stickyLogoImg;
      }
      this.isSticky = true;
      return;
    }

    header.classList.remove('menu-sticky', 'animated', 'slideInDown', 'slideWhite');
    this.displayLogoImg = this.logoImg;
    this.isSticky = false;
  }
}
